<aside
  *ngIf="authenticated && !booth && !landingPage"
  [style.--primary-color]="colors.primaryColor"
  [style.--primary-color-2]="colors.primaryColor2"
  [style.--secondary-color]="colors.secondaryColor"
  [style.--font-color]="colors.fontColor"
  [style.--header-background-color]="colors.headerBackgroundColor"
  [style.--nav-background-color]="colors.navBackgroundColor"
  [style.--bottom-nav-background-color]="colors.bottomNavBackgroundColor"
  [style.--nav-link-color]="colors.navLinkColor"
  [style.--headline-color]="colors.headlineColor"
  [style.--toolbar-button-color]="colors.toolbarButtonColor"
  [style.--toolbar-button-font-color]="colors.toolbarButtonFontColor"
  [style.--login-button-font-color]="colors.loginButtonFontColor"
  [style.--login-button-background-color]="colors.loginButtonBackgroundColor"
  [style.--login-background-color]="colors.loginBackgroundColor"
  [style.--module-background-color]="colors.moduleBackgroundColor"
  [style.--sub-headline-color]="colors.subheadlineColor"
  [style.--card-color]="colors.cardColor"
  [style.--reg-headline-color]="colors.regHeadlineColor"
  [style.--module-background-color-2]="colors.moduleBackgroundColor2"
>
  <app-navigation></app-navigation>
</aside>
<main
  [class.fullsize]="!authenticated || landingPage"
  [style.--primary-color]="colors.primaryColor"
  [style.--primary-color-2]="colors.primaryColor2"
  [style.--secondary-color]="colors.secondaryColor"
  [style.--font-color]="colors.fontColor"
  [style.--header-background-color]="colors.headerBackgroundColor"
  [style.--nav-background-color]="colors.navBackgroundColor"
  [style.--bottom-nav-background-color]="colors.bottomNavBackgroundColor"
  [style.--nav-link-color]="colors.navLinkColor"
  [style.--headline-color]="colors.headlineColor"
  [style.--toolbar-button-color]="colors.toolbarButtonColor"
  [style.--toolbar-button-font-color]="colors.toolbarButtonFontColor"
  [style.--login-button-font-color]="colors.loginButtonFontColor"
  [style.--login-button-background-color]="colors.loginButtonBackgroundColor"
  [style.--login-background-color]="colors.loginBackgroundColor"
  [style.--module-background-color]="colors.moduleBackgroundColor"
  [style.--sub-headline-color]="colors.subheadlineColor"
  [style.--card-color]="colors.cardColor"
  [style.--reg-headline-color]="colors.regHeadlineColor"
  [style.--module-background-color-2]="colors.moduleBackgroundColor2"
  [class.gradient-module]="colors.moduleBackgroundColor2"
>
  <router-outlet></router-outlet>
</main>
